import React from "react";
import "./navigation.css";

function Navigation() {
  return (
    <div>
      <div className="welcome-img-logo">
        <img src="https://i.imgur.com/tSGs1vr.jpeg" className="img-landing" alt="img-landing"/>

        <div className="logo-and-text">
          <div className="text-passion">
            <h1 className="heading-home fade-in-2">More than a job,</h1>
            <h2 className="heading-home fade-in-3">It's what we love.</h2>
          </div>
        </div>

        <div className="button-home">
          <a href="/about-us" className="bookmeetgreet">
            How It All Started
          </a>
          <a href="/customerform" className="bookmeetgreet">
            New Customer Inquiry Form
          </a>
        </div>
      </div>
    </div>
  );
}

export default Navigation;
